import { render, staticRenderFns } from "./ModalNewSetupPackageWiki.vue?vue&type=template&id=08987070&scoped=true&"
import script from "./ModalNewSetupPackageWiki.vue?vue&type=script&lang=js&"
export * from "./ModalNewSetupPackageWiki.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewSetupPackageWiki.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalNewSetupPackageWiki.vue?vue&type=style&index=1&id=08987070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08987070",
  null
  
)

export default component.exports